export function characterCount(value: string): number {
  return Array.from(value).length;
}

export function cleanUserText(value: string): string {
  return value
    .replace(/[<>]/g, "")
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
    .replace(/\s+/gu, " ")
    .trim();
}

export function isQuestionLengthValid(value: string): boolean {
  const count = characterCount(cleanUserText(value));
  return count >= 5 && count <= 20;
}

export function isActionLengthValid(value: string): boolean {
  const count = characterCount(cleanUserText(value));
  return count >= 1 && count <= 100;
}

export function isThirdAnswerValid(value: string): boolean {
  const count = characterCount(cleanUserText(value));
  return count >= 1 && count <= 80;
}

export function clampByCharacters(value: string, max: number): string {
  return Array.from(value).slice(0, max).join("");
}

export function actionKeywordFromText(value: string): "尝试" | "坚持" | "倾听" | "学习" | "责任" | "改变" | "合作" | "行动" {
  if (/尝试|试试|开始/.test(value)) return "尝试";
  if (/坚持|继续|完成|复盘/.test(value)) return "坚持";
  if (/听|沟通|理解/.test(value)) return "倾听";
  if (/学|阅读|练习/.test(value)) return "学习";
  if (/责任|承担|分担/.test(value)) return "责任";
  if (/改变|调整|改进/.test(value)) return "改变";
  if (/合作|伙伴|一起/.test(value)) return "合作";
  return "行动";
}
